import { SearchFields } from "@examspark/types/dist/components/activity-editor";

export const getGenericQuery = (term: string) => {
  const query: any = [];
  const existsMatch = term.match(/^exists:(.*)/);
  const emptyMatch = term.match(/^empty:(.*)/);
  const idMatch = term.match(/^id:(.*)/i);
  const uuidMatch = term.match(
    new RegExp(
      "/^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i/",
    ),
  );

  if (existsMatch) {
    query.push({
      [existsMatch[1]]: {
        exists: true,
      },
    });
  } else if (emptyMatch) {
    query.push({
      [emptyMatch[1]]: {
        exists: false,
      },
    });
  } else if (idMatch) {
    query.push({
      or: [
        {
          id: {
            eq: idMatch[1],
          },
        },
        {
          idInc: {
            eq: idMatch[1],
          },
        },
        {
          idVendor: {
            wildcard: `*${idMatch[1]}*`,
          },
        },
      ],
    });
  } else if (uuidMatch) {
    query.push({
      id: {
        eq: term,
      },
    });
  } else {
    query.push({
      or: [
        {
          name: {
            matchPhrase: term,
          },
        },
        {
          id: {
            eq: term,
          },
        },
        {
          idInc: {
            eq: term,
          },
        },
        {
          idVendor: {
            eq: term,
          },
        },
        {
          keywords: {
            eq: term,
          },
        },
        // {
        //   fullText: {
        //     eq: term,
        //   },
        // },
        {
          tags: {
            eq: `${term}#`,
          },
        },
        {
          tags: {
            eq: `#${term}`,
          },
        },
      ],
    });
  }

  return query;
};

export const getSearchQueryForField = (
  field: keyof SearchFields,
  values: string[],
) => {
  if (!values?.length) return null;
  return {
    or: values.map((v) => {
      return {
        [field]: {
          eq: v,
        },
      };
    }),
  };
};
